import { BranchingQueryDefinition, getChildEdgeTypeId } from '@iotv/datamodel';
import { AdjacentType, ComparisonType, LogicalOperatorType } from '@iotv/iotv-v3-types';
/**
 * Existing edges doesn't have edgeTypeId and will fail, now that it is defined in the edgeTypeMatrix
 * Enable when gateways with this edge are added
 */
const GATEWAY_HAS_EDGES = false;
export const getGatewayProperty = () => {
    const apexQuery = new BranchingQueryDefinition({
        id: 'apex',
        path: [{ adjacencyType: AdjacentType.SUBJECT, objectTypeId: 'Gateway' }],
        subQueries: [],
    });
    const gatewayToGroupQuery = new BranchingQueryDefinition({
        id: 'gatewayToGroupQuery',
        path: [
            {
                objectTypeId: 'Group',
                adjacencyType: AdjacentType.PARENT,
                edgeTypeId: GATEWAY_HAS_EDGES ? getChildEdgeTypeId('Gateway', 'Group') : undefined,
                nodeFilters: [
                    {
                        filters: [{ key: 'supportedType', predicate: ComparisonType.EQUALS, value: 'Gateway' }],
                        setOperation: LogicalOperatorType.OR,
                    },
                ],
            },
        ],
        subQueries: [],
    });
    const groupToGroupQuery = new BranchingQueryDefinition({
        id: 'groupToGroupQuery',
        path: [
            {
                objectTypeId: 'Group',
                adjacencyType: AdjacentType.PARENT,
                edgeTypeId: GATEWAY_HAS_EDGES ? getChildEdgeTypeId('Group', 'Group') : undefined,
                nodeFilters: [
                    {
                        filters: [{ key: 'supportedType', predicate: ComparisonType.EQUALS, value: 'Gateway' }],
                        setOperation: LogicalOperatorType.AND,
                    },
                ],
            },
        ],
        subQueries: [],
    });
    const groupToPropertyQuery = new BranchingQueryDefinition({
        id: 'groupToPropertyQuery',
        path: [
            {
                objectTypeId: 'Property',
                adjacencyType: AdjacentType.PARENT,
                edgeTypeId: GATEWAY_HAS_EDGES ? getChildEdgeTypeId('Group', 'Property') : undefined,
            },
        ],
        subQueries: [],
    });
    const groupToCustomerQuery = new BranchingQueryDefinition({
        id: 'groupToCustomerQuery',
        path: [
            {
                objectTypeId: 'Customer',
                adjacencyType: AdjacentType.PARENT,
                edgeTypeId: GATEWAY_HAS_EDGES ? getChildEdgeTypeId('Group', 'Customer') : undefined,
            },
        ],
        subQueries: [],
    });
    const gatewayToPropertyQuery = new BranchingQueryDefinition({
        id: 'gatewayToPropertyQuery',
        path: [
            {
                objectTypeId: 'Property',
                adjacencyType: AdjacentType.PARENT,
                edgeTypeId: GATEWAY_HAS_EDGES ? getChildEdgeTypeId('Gateway', 'Property') : undefined,
            },
        ],
        subQueries: [],
    });
    const propertyToCustomerQuery = new BranchingQueryDefinition({
        id: 'propertyToCustomerQuery',
        path: [
            {
                objectTypeId: 'Customer',
                adjacencyType: AdjacentType.PARENT,
                edgeTypeId: GATEWAY_HAS_EDGES ? getChildEdgeTypeId('Property', 'Customer') : undefined,
            },
        ],
        subQueries: [],
    });
    apexQuery.addSubQuery(gatewayToGroupQuery);
    apexQuery.addSubQuery(gatewayToPropertyQuery);
    groupToGroupQuery.addSubQuery(groupToGroupQuery);
    groupToGroupQuery.addSubQuery(groupToPropertyQuery);
    gatewayToGroupQuery.addSubQuery(groupToCustomerQuery);
    groupToGroupQuery.addSubQuery(groupToCustomerQuery);
    groupToPropertyQuery.addSubQuery(propertyToCustomerQuery);
    gatewayToPropertyQuery.addSubQuery(propertyToCustomerQuery);
    const res = {
        query: apexQuery,
        dehydrated: apexQuery.dehydrate(),
    };
    return res;
};
/**
 * Returns the gateways belonging to a customer
 */
export const getCustomersGatewaysQuery = () => {
    const apexQuery = new BranchingQueryDefinition({
        id: 'apex',
        path: [{ adjacencyType: AdjacentType.SUBJECT, objectTypeId: 'Customer' }],
        subQueries: [],
    });
    const customerToGroupQuery = new BranchingQueryDefinition({
        id: 'customerToGroupQuery',
        path: [
            {
                objectTypeId: 'Group',
                adjacencyType: AdjacentType.CHILD,
                edgeTypeId: GATEWAY_HAS_EDGES ? getChildEdgeTypeId('Customer', 'Group') : undefined,
                nodeFilters: [
                    {
                        filters: [{ key: 'supportedType', predicate: ComparisonType.EQUALS, value: 'Gateway' }],
                        setOperation: LogicalOperatorType.OR,
                    },
                ],
            },
        ],
        subQueries: [],
    });
    const groupToGatewayQuery = new BranchingQueryDefinition({
        id: 'groupToGroupQuery',
        path: [
            {
                objectTypeId: 'Gateway',
                adjacencyType: AdjacentType.CHILD,
                edgeTypeId: GATEWAY_HAS_EDGES ? getChildEdgeTypeId('Group', 'Gateway') : undefined,
            },
        ],
        subQueries: [],
    });
    apexQuery.addSubQuery(customerToGroupQuery);
    customerToGroupQuery.addSubQuery(groupToGatewayQuery);
    const res = {
        query: apexQuery,
        dehydrated: apexQuery.dehydrate(),
    };
    return res;
};
